(function ($) {
  'use strict';

  $(document).ready(function () {

    // Convert linked SVG files to inline for CSS/JS manipulation.
    SVGInject($('img.svg').get());

    // Resets button states when mousing out (webkit).
    $(document).on('mouseleave', '.uc-menu a, .btn', function () {
      $(this).blur();
    });
  });

  $(window).on('load', function () {

    // Converts list 'start' attribute to a CSS style that can be used.
    $('ol[start]').each(function () {
      var val = parseFloat($(this).attr('start')) - 1;
      $(this).css('counter-increment', 'item ' + val);
    });
  });

})(jQuery);
